import React from 'react';
import QuickActionCard from './QuickActionCard';

const FinanceActions = ({ userRoles }) => {
  // Only render for Finance users - Early return for performance
  if (!userRoles.includes('Finance')) {
    return null;
  }

  return (
    <>
      <QuickActionCard
        to="/payments"
        title="Payment Management"
        description="Process approved claim payments"
        icon={
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
        }
        iconColor="text-green-600"
        hoverIconColor="group-hover:text-green-700"
        titleHoverColor="group-hover:text-green-700"
      />

      <QuickActionCard
        to="/sla-dashboard"
        title="SLA Monitoring"
        description="Track payout SLA compliance and escalations"
        icon={
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        }
        iconColor="text-orange-600"
        hoverIconColor="group-hover:text-orange-700"
        titleHoverColor="group-hover:text-orange-700"
        badge="sla"
      />
    </>
  );
};

export default React.memo(FinanceActions);
